import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class BulkWizardDataService {

    constructor(private utilityService: UtilityService,
        private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) {
    }

    // Page Load
    createPageLoadProperties(url: string, title: string, pageName: string) {
        const dataLayer = {};
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = pageName;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
        this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
    }

    tokenRefresh() {
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
    }
}
